// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\r\n\r\n.N3GEUYlFrjXJRzxzn3sG {\r\n  height: 3rem;\r\n  width: 3rem;\r\n  background-color: red;\r\n}\r\n\r\n.krhbC2YaZitsNZtVdrvw {\r\n  height: 100vh;\r\n  font-size: 10rem;\r\n}", "",{"version":3,"sources":["webpack://./src/components/Four/SpringStyles.css"],"names":[],"mappings":";;AAEA;EACE,YAAY;EACZ,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB","sourcesContent":["\r\n\r\n.dragDiv {\r\n  height: 3rem;\r\n  width: 3rem;\r\n  background-color: red;\r\n}\r\n\r\n.section {\r\n  height: 100vh;\r\n  font-size: 10rem;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dragDiv": "N3GEUYlFrjXJRzxzn3sG",
	"section": "krhbC2YaZitsNZtVdrvw"
};
export default ___CSS_LOADER_EXPORT___;
